import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  FormControl,
  Grid,
  Grow,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import React, { ReactElement, useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import { ListSkeleton } from "components/listSkeleton";
import style from "./index.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/store/store";
import { HomeBannerForm } from "./HomeBannerForm";
import { getAllHomeBanner } from "redux/actions/bhandaraActions";
import moment from "moment";
import { MenuProps } from "styles/global.styles";

interface State {
  editing?: boolean;
  editItem?: any;
  lang: number;
}

export default function HomeBanner(): ReactElement {
  const dispatch = useDispatch();
  const contentList = useSelector((state: RootState) => state.bhandara.homeBannerList);

  const initialState: State = {
    editing: false,
    editItem: null,
    lang: 1,
  };

  const [language, setLanguage] = useState<any>(1);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [states, setStates] = useState<State>(initialState);
  const [searchMessage, setsearchMessage] = useState("");
  const [searchData, setsearchData] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const languages = useSelector((state: RootState) => state.app.languages);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
    setsearchMessage("");
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setsearchMessage("");
  };

  const onClickBack = () => {
    setCurrentIndex(0);
    setsearchMessage("");
    setStates({
      editing: false,
      editItem: null,
      lang: language,
    });
  };

  useEffect(() => {
    dispatch(getAllHomeBanner(rowsPerPage, page, language));
  }, [dispatch, page, rowsPerPage, language]);

  const renderMessagelist = (data: any) => {
    return (
      <div>
        {data.length ? (
          <>
            <TableContainer style={{ maxHeight: "400px" }} className={style.scrollbar}>
              <Table stickyHeader aria-label="sticky table" size="small">
                <TableHead>
                  <TableRow style={{ fontWeight: "bold" }}>
                    <TableCell
                      align="left"
                      sx={{
                        width: "40%",
                      }}
                    >
                      Title
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        width: "20%",
                      }}
                    >
                      Image
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        width: "20%",
                      }}
                    >
                      Published Date
                    </TableCell>
                    <TableCell
                      align="left"
                      sx={{
                        width: "20%",
                      }}
                    >
                      Status
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(searchMessage !== "" ? searchData : data).map((item: any, x: any) => {
                    let cardData = item?.carddata ? JSON.parse(item?.carddata) : "";

                    return (
                      <React.Fragment key={x}>
                        <TableRow
                          sx={{ cursor: "pointer", height: "50px" }}
                          hover
                          onClick={() => {
                            setStates({
                              editing: true,
                              editItem: item,
                              lang: language,
                            });
                            setCurrentIndex(1);
                          }}
                        >
                          <TableCell align="left">
                            {cardData.title ? (
                              cardData.title
                            ) : (
                              <Chip variant="filled" label="Content is not set for this language" />
                            )}
                          </TableCell>
                          <TableCell align="center">
                            <Avatar alt="" src={cardData.image} />
                          </TableCell>
                          <TableCell align="left">
                            {moment(Number(item.createddate.seconds) * 1000).format("DD/MM/YYYY")}
                          </TableCell>
                          <TableCell align="left">
                            {item.ispublished ? "Published" : "Unpublished"}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={
                searchMessage !== ""
                  ? searchData.length
                  : contentList.messages.responsepageable.totalcount
              }
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              style={{ borderTop: "1px solid rgba(0, 0, 0, 0.12)" }}
              className={style.scrollbar}
            />
          </>
        ) : (
          <Box height={350}>
            <Grid
              container
              style={{
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h6" color="textSecondary">
                No Cards to show
              </Typography>
            </Grid>
          </Box>
        )}
      </div>
    );
  };

  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <Card className="mt-3 mb-5">
            <Grow
              in={currentIndex === 0}
              mountOnEnter
              unmountOnExit
              style={{ transformOrigin: "0 0 0" }}
              {...(currentIndex === 0 ? { timeout: 1000 } : {})}
            >
              <div>
                <Grid container className="align-items-center p-3" spacing={2}>
                  <Grid item>
                    <Typography variant="h6">Home Banner</Typography>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setCurrentIndex(1);
                        setStates({
                          editing: false,
                          editItem: null,
                          lang: language,
                        });
                      }}
                      startIcon={<AddIcon />}
                    >
                      Add Home Banner
                    </Button>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm={4} md={4} lg={3}>
                  <FormControl variant="outlined" className="m-3" fullWidth>
                    <InputLabel id="language-select">Language</InputLabel>
                    {languages && (
                      <Select
                        defaultValue=""
                        labelId="language-select"
                        value={language}
                        label="Language"
                        onChange={e => {
                          setLanguage(e.target.value as number);
                        }}
                        MenuProps={MenuProps}
                      >
                        {languages.map((lang: any, i: any) => (
                          <MenuItem key={i} value={lang.code}>
                            {lang.displayName}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </FormControl>
                </Grid>
                <Divider />
                <CardContent>
                  <Paper>
                    {contentList.loading
                      ? ListSkeleton()
                      : renderMessagelist(contentList.messages.listofcardsList)}
                  </Paper>
                </CardContent>
              </div>
            </Grow>
            <Grow
              in={currentIndex === 1}
              mountOnEnter
              unmountOnExit
              style={{ transformOrigin: "0 0 0" }}
              {...(currentIndex === 1 ? { timeout: 1000 } : {})}
            >
              <HomeBannerForm
                isEditing={states.editing}
                editItem={states.editItem}
                lang={states.lang}
                onClickBack={onClickBack}
                page={page}
                rowsPerPage={rowsPerPage}
              />
            </Grow>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
